import { Component} from '@angular/core';
import { IKnUIOptions } from '../../models/graph-kn.cm-api-models';
import { Subscription } from 'rxjs';
import { GraphKnDataService } from '../../services/graph-kn.data.service';
import { IGraphNode } from '../../models/graph-kn.model-interfaces';
@Component({
    selector: 'app-node-toolbar',
    templateUrl: './node-toolbar.component.html',
    styleUrl: './node-toolbar.component.scss'
})
export class AppNodeToolbarComponent {
	public rights:IKnUIOptions|undefined = undefined
	private node:IGraphNode|undefined = undefined
	private subs:Subscription = new Subscription
	constructor(
		private knDataService: GraphKnDataService
	) {	}
	ngOnInit(): void {
		this.subs.add(this.knDataService.subToolBarOpen.asObservable().subscribe(res=> {
			this.rights = res.rights;
			this.node = res.data as IGraphNode
		}))
	}
	ngOnDestroy(): void {
		this.subs.unsubscribe()
	}
	createNode(){
		if (!this.node) {
			return
		}
		this.knDataService.emitNodeEvent.emit({
			action: 'ADD_NODE',
			data: this.node,
			canEdit: true,
			pureAction: true
		})
	}
	createEdge(){
		if (!this.node) {
			return
		}
		this.knDataService.emitNodeEvent.emit({
			action: 'ADD_EDGE',
			data: this.node,
			canEdit: true,
			pureAction: true
		})
	}
	viewNode(){
        if (!this.node) {
            return
        }
        this.knDataService.emitNodeEvent.emit({
            action: 'VIEW_NODE',
            data: this.node,
            canEdit: false,
            pureAction: true
        })
		
	}
	editNode (){
		if (!this.node) {
			return
		}
		this.knDataService.emitNodeEvent.emit({
			action: 'EDIT_NODE',
			data: this.node,
			canEdit: true,
			pureAction: true
		})
	}
	deleteNode() {
		if (!this.node) {
			return
		}
		this.knDataService.emitNodeEvent.emit({
			action: 'DELETE_NODE',
			data: this.node,
			canEdit: true,
			pureAction: true
		})
    }
    isCreateEdgeShown():boolean|undefined {
        return this.rights?.showCreateEdge && this.node?.bp_status_data?.is_universal !== true && this.node?.bp_status_data?.is_archive !== true
    }
    isCreateNodeShown():boolean|undefined {
        return this.rights?.showCreateNode && this.node?.bp_status_data?.is_universal !== true && this.node?.bp_status_data?.is_archive !== true
    }
    isDeleteNodeShown():boolean|undefined {
        return this.rights?.showDelete && this.node?.bp_status_data?.is_initial !== true && this.node?.bp_status_data?.is_archive !== true
    }
    isEditNodeShown():boolean|undefined {
        return this.rights?.showEdit
    }
    isViewNodeShown():boolean|undefined {
        return this.rights?.showEdit !== true
    }
}
